import { Link } from 'react-router-dom';

interface Crumb {
  label: string;
  to?: string;
}

interface Props {
  items: Crumb[];
}

export default function Breadcrumb({ items }: Props) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1.5 text-xs text-foreground-500">
      <Link to="/" className="hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap">
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-300 w-3.5 h-3.5 flex items-center justify-center" />
          {item.to ? (
            <Link
              to={item.to}
              className="hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}